<div class="customers-table-row heads">
  <span *ngFor="let head of heads" [innerHTML]="head"></span>
</div>
  <ng-content></ng-content>
